export const TAX_CLASSES_REDUCER_NAME = 'tax-classes';

export const taxClassesReducer = (state = {}) => state;

export const getTaxClasses = (state) => state[TAX_CLASSES_REDUCER_NAME];
